import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setIsProductConfirmed } from '../../store/slices/confirmationSlice';
import { showNotification } from '../../store/slices/notificationSlice';
import { useCartMessaging } from '../useCartMessaging';
import { selectSelectedProduct } from '../../store/selectors';

export const useProductConfirmation = () => {
  const dispatch = useAppDispatch();
  const [confirmButtonClicked, setConfirmButtonClicked] = useState(false);
  const selectedVariantId = useAppSelector((state) => state.game.selectedVariantId);
  const currentSelectedProduct = useAppSelector(selectSelectedProduct);
  const { addToCart, loading: cartLoading } = useCartMessaging();

  const handleConfirmProductClick = () => {
    if (!currentSelectedProduct) {
      console.warn('No product selected for confirmation');
      return;
    }

    if (!selectedVariantId) {
      console.warn('No variant selected for confirmation');
      dispatch(
        showNotification({
          message: 'Please select a product variant.',
          yPosition: 60,
        })
      );
      return;
    }

    if (confirmButtonClicked) {
      return;
    }

    setConfirmButtonClicked(true);
    dispatch(setIsProductConfirmed(true));

    try {
      addToCart(Number(selectedVariantId), 1);
    } catch (error) {
      console.error('Failed to initiate add to cart:', error);
      dispatch(
        showNotification({
          message: 'Failed to add product to cart. Please try again.',
          yPosition: 60,
        })
      );
      setConfirmButtonClicked(false); // Allow retry
    }
  };

  return {
    handleConfirmProductClick,
    confirmButtonClicked,
    cartLoading,
    currentSelectedProduct,
  };
};
